/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var OutForSignatureStatusIcon = createIcon("OutForSignatureStatusIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#665AF4';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "m14.482 4.154-8.95 8.95-2.65-2.652 8.877-8.875a1.944 1.944 0 012.482-.276 1.875 1.875 0 01.241 2.853v0Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.824 1.512a1.875 1.875 0 00-2.645.006L7.187 3.507m2.323.316 2.652 2.651M.969 15.031l1.912-4.58 2.651 2.652L.97 15.031Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});